import { supabase } from "../lib/supabase";

const API_BASE = process.env.REACT_APP_API_BASE || "";

async function postSchoolName(body) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) throw new Error("Bitte melde dich an.");
  const res = await fetch(`${API_BASE}/api/school-name`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Speichern hat nicht geklappt.");
  }
  return data;
}

/** @param {string} name */
export function matchSchoolName(name) {
  return postSchoolName({ action: "match", name });
}

/** @param {string} text */
export function detectSchoolName(text) {
  return postSchoolName({ action: "detect", text });
}

/**
 * @param {{ packId: string, childId?: string|null }} args
 */
export function confirmSchoolName({ packId, childId = null }) {
  return postSchoolName({ action: "confirm", packId, childId });
}

/**
 * @param {{ name: string, childId?: string|null }} args
 */
export function fileOtherSchoolName({ name, childId = null }) {
  return postSchoolName({ action: "other", name, childId });
}
